import { render, staticRenderFns } from "./Alarms.vue?vue&type=template&id=0cf44f6a&"
import script from "./Alarms.vue?vue&type=script&lang=js&"
export * from "./Alarms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports